export const GLOBAL_COMPS = {
  // offcanvases
  MAIN_OFFCANVAS: 'mainOffcanvasOpen',
  FILTER_OFFCANVAS: 'filterOffcanvasOpen',
  //modals
  HOTKEYS_MODAL: 'hotkeysModalOpen',
  SIGN_IN_MODAL: 'signInModalOpen',
  SIGN_UP_MODAL: 'signUpModalOpen',
  CHANGE_PASSWORD_MODAL: 'changePasswordModalOpen',
  DELETE_ACCOUNT_MODAL: 'deleteAccountModalOpen',
  CART_MODAL: 'cartModalOpen',
  WRITE_REVIEW_MODAL: 'writeReviewModalOpen',
}
